/** Monthly category spend is dated by each live cost line, never by WO opening. */
export interface ReportJobFilter {
  jobCategoryId?: string;
  /** Current primary/additional WO vendor membership; full eligible job costs,
   * not a claim that the selected vendor billed every included cost. */
  vendorId?: string;
}

/**
 * TRBUD-448: the In-house / Vendor choice on the monthly work-type chart. The
 * same two values, and the same rule, as the Work orders page filter
 * (TRBUD-357). Absent means every job.
 */
export const reportRepairKinds = ["INTERNAL", "VENDOR"] as const;
export type ReportRepairKind = (typeof reportRepairKinds)[number];

export interface MonthlyWorkTypeActivity {
  filters?: ReportJobFilter;
  /** TRBUD-448: echoed so the chart's drill asks for the same jobs it counted. */
  repairKind?: ReportRepairKind;
  start: string | null;
  end: string;
  rows: Array<{ month: string; typeId: string; typeName: string; opened: number; completed: number }>;
  jobs: Array<{ workOrderId: string; number: string; title: string | null; date: string }>;
  hasMore: boolean;
}

export interface CategoryPeriodSpend {
  filters?: ReportJobFilter;
  start: string | null;
  end: string;
  rows: Array<{ categoryId: string | null; categoryName: string; currency: string; amount: string; workOrders: number }>;
  totals: Array<{ currency: string; amount: string; workOrders: number }>;
  lines: Array<{ id: string; workOrderId: string; workOrderNumber: string; title: string | null; date: string; currency: string; amount: string; source: string }>;
  hasMore: boolean;
}
